import React, {
  useEffect,
  useState,
  useRef,
  useMemo,
  useCallback,
} from "react";
import axios from "axios";
import { useAppContext } from "../../AppContext"; // Adjust the path as needed
import Pagination from "@mui/material/Pagination";
import Drawer from "@mui/material/Drawer";
import CloseImg from "../../Images/CloseImg.png";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { MyDomain } from "../../App";

export default function DeliveryOrdersGet() {
  const [ChooseDirection, setChooseDirection] = useState("All Districts");

  const Direction = [
    "All Districts",
    "Northern District",
    "Southern District",
    "Jerusalem District",
    "Southern Triangle",
    "Northern Triangle",
    "Haifa and Carmel region",
  ];
  const { User, Token } = useAppContext();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [OrdersWithAllData, setOrdersWithAllData] = useState([]);
  const [OrdersWithAllDataDelivery, setOrdersWithAllDataDelivery] = useState(
    []
  );
  const [OpenDrawer, setOpenDrawer] = useState(false);
  const [CloseDrawer, setCloseDrawer] = useState(false);
  const [OrderOBJ, setOrderOBJ] = useState("");

  const GetAllOrdersWithAllData = async () => {
    if (!User || !Token) {
      setError("User or Token is missing");
      setLoading(false);
      return;
    }
    try {
      const response = await axios.get(
        `${MyDomain}Orders/GetAllOrdersWithAllDataForDelivery`,
        {
          headers: {
            Authorization: `Bearer ${Token}`,
          },
          //params: { Id: User.userId },
        }
      );
      console.log(response.data);
      setOrdersWithAllData(response.data);
      setOrdersWithAllDataDelivery(response.data);
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {
    GetAllOrdersWithAllData();
  }, []);

  const handleOpenLoginPopOver = (newOpen) => {
    setOrderOBJ("");
    setOpenDrawer(newOpen);
  };
  const [page, setPage] = useState(1);
  const itemsPerPage = 5;

  const handleChange = (event, value) => {
    setPage(value);
  };

  const totalPages = Math.ceil(OrdersWithAllDataDelivery.length / itemsPerPage);
  const startIndex = (page - 1) * itemsPerPage;
  const paginatedOrders = OrdersWithAllDataDelivery.slice(
    startIndex,
    startIndex + itemsPerPage
  );

  const DrawerFunc = () => {
    return (
      <>
        <Drawer
          open={OpenDrawer}
          //onClose={CloseDrawer} //CloseMobileDrawerFunc
          onOpenChange={handleOpenLoginPopOver}
          anchor="bottom"
          PaperProps={{
            style: {
              height: "auto", // Height adjusts to content
              //maxHeight: "90vh", // Optional: Limit max height
              overflow: "auto", // Enable scrolling
              //padding: "10px",
              height: "50%",
            },
          }}
        >
          <div
            style={{
              display: "flex",
              width: "100%",
              //justifyContent: "flex-end",
              paddingTop: 10,
              paddingBottom: 30,
              flexDirection: "column",
            }}
          >
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <img
                onClick={() => {
                  setOpenDrawer(false);
                }}
                src={CloseImg}
                alt={"Expand"}
                style={{ width: 30, height: 30, cursor: "pointer" }}
              />
            </div>
            <div
              style={{
                display: "flex",
                //alignItems: "flex-end",
                //justifyContent: "flex-end",
                paddingBottom: 10,
                marginTop: 20,
                marginLeft: "1%",
                marginRight: "1%",
                flexDirection: "column",
              }}
            >
              <a>ID: {OrderOBJ?.order?.id}</a>
              <a>
                Name: {OrderOBJ?.addresses?.firstName}{" "}
                {OrderOBJ?.addresses?.lastName}{" "}
              </a>
              <a>Phone number: {OrderOBJ?.addresses?.phonenumber}</a>
              <a>City: {OrderOBJ?.addresses?.city}</a>
              <a>Price: {OrderOBJ?.order?.price} ₪</a>

              <div
                style={{
                  display: "flex",
                  paddingTop: "10%",
                  justifyContent: "center",
                  alignContent: "center",
                }}
              >
                <button
                  style={{ width: 200, height: 50 }}
                  onClick={() => {
                    handleClickOpen(!open);
                  }}
                >
                  Done
                </button>
              </div>
              {/* <a>Direction: {OrderOBJ?.addresses?.direction}</a> */}
            </div>
          </div>
        </Drawer>
      </>
    );
  };

  const handleUpdateOrderStatus = async (OrderId) => {
    const data = {
      Id: OrderId,
      OrderStatus: 3,
    };
    console.log(data);
    try {
      const response = await axios.put(
        `${MyDomain}Orders/UpdateOrderStatus`,
        data,
        {
          headers: {
            Authorization: `Bearer ${Token}`,
            "Content-Type": "application/json",
          },
        }
      );
      console.log(response.data);
      handleClose();
      setOrdersWithAllDataDelivery((prevOrders) =>
        prevOrders.filter((order) => order.order.id !== OrderId)
      );
      setOpenDrawer(false);
    } catch (error) {
      console.log("Login error:", error.response?.data || error.message);
    }
  };
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = (value) => {
    setOpen(value);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const DialogFunc = () => {
    return (
      <>
        <React.Fragment>
          <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            PaperProps={{
              style: { width: "90%", maxWidth: "none" },
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                paddingRight: 10,
                paddingTop: 10,
              }}
            >
              <img
                onClick={handleClose}
                src={CloseImg}
                alt={"Expand"}
                style={{ width: 30, height: 30, cursor: "pointer" }}
              />
            </div>

            {/* <DialogContent>
              <DialogContentText id="alert-dialog-description">
                Does client recieve the order ?
              </DialogContentText>
            </DialogContent> */}
            <div
              style={{
                display: "flex",
                width: "100%",
                //backgroundColor: "red",
                justifyContent: "space-around",
                alignItems: "center",
                padding: 20,
              }}
            >
              <a>are you sure client recieve the order ?</a>
            </div>
            <div
              style={{
                display: "flex",
                width: "100%",
                //backgroundColor: "red",
                justifyContent: "space-around",
                alignItems: "center",
                padding: 20,
              }}
            >
              <button
                onClick={handleClose}
                style={{
                  backgroundColor: "black",
                  color: "white",
                  border: 0,
                  width: 80,
                  height: 35,
                }}
              >
                No
              </button>

              <button
                style={{
                  backgroundColor: "black",
                  color: "white",
                  border: 0,
                  width: 80,
                  height: 35,
                }}
                onClick={() => {
                  handleUpdateOrderStatus(OrderOBJ?.order?.id);
                }}
              >
                Yes
              </button>
            </div>
          </Dialog>
        </React.Fragment>
      </>
    );
  };
  return (
    <div style={{ paddingLeft: "1%", paddingRight: "1%" }}>
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "5px",
        }}
      >
        {Direction.map((direction, index) => (
          <div
            key={index}
            style={{
              flex: "1 1 calc(25% - 10px)", // 4 items per row, with spacing
              minWidth: "150px", // Minimum size before wrapping
              boxSizing: "border-box",
              padding: "5px",
              border: "1px solid #ccc",
              borderRadius: "8px",
              background: direction === ChooseDirection ? "black" : "#f9f9f9",
              textAlign: "center",
              fontSize: "14px",
              color: direction === ChooseDirection ? "white" : "black",
            }}
            onClick={() => {
              setChooseDirection(direction);
              if (direction === "All Districts") {
                setOrdersWithAllDataDelivery(OrdersWithAllData);
              } else {
                console.log(direction);
                setOrdersWithAllDataDelivery(
                  OrdersWithAllData.filter(
                    (item) => item.addresses.direction === direction
                  )
                );
              }
            }}
          >
            {direction}
          </div>
        ))}
      </div>

      <div style={{ paddingTop: 20 }}>
        {paginatedOrders.map((Orders) => (
          <div
            key={Orders?.order?.id}
            style={{
              display: "flex",
              border: "1px solid #ccc",
              padding: 5,
              marginBottom: 5,
              flexDirection: "column",
            }}
            onClick={() => {
              console.log(Orders);
              setOrderOBJ(Orders);
              setOpenDrawer(true);
            }}
          >
            <a style={{ fontSize: 14 }}>ID: {Orders?.order?.id}</a>
            <a style={{ fontSize: 14 }}>
              Name: {Orders?.addresses?.firstName} {Orders?.addresses?.lastName}{" "}
            </a>
            <a style={{ fontSize: 14 }}>City: {Orders?.addresses?.city}</a>
          </div>
        ))}

        <div style={{ display: "flex", justifyContent: "center" }}>
          <Pagination
            count={totalPages}
            page={page}
            onChange={handleChange}
            color="primary"
          />
        </div>
      </div>
      {DrawerFunc()}
      {DialogFunc()}
    </div>
  );
}
